// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__b5nTP","slide-in-bottom":"tooltip_slide-in-bottom__E8TuD"};